import CategoryPage from 'Route/CategoryPage/CategoryPage.component';

export class SearchPage extends CategoryPage {
    renderCategoryDetails() {
        const { search } = this.props;

        return (
            <article block="CategoryDetails">
                <div block="CategoryDetails" elem="Description">
                <h1
                  block="CategoryDetails"
                  elem="Heading"
                  mix={ {
                      block: 'SearchPage',
                      elem: 'Heading'
                  } }
                >
                    { __('Results for: %s', search) }
                </h1>
                </div>
            </article>
        );
    }

    renderCmsBlock() {
        return null;
    }
}

export default SearchPage;
